const key = 'biograph-custom-stack'

export function readBuilder(): string[] {
  try {
    const value = JSON.parse(localStorage.getItem(key) || '[]')
    return Array.isArray(value) ? value.filter((item) => typeof item === 'string').slice(0, 8) : []
  } catch {
    return []
  }
}

export function writeBuilder(ids: string[]) {
  const next = [...new Set(ids)].slice(0, 8)
  localStorage.setItem(key, JSON.stringify(next))
  window.dispatchEvent(new CustomEvent('biograph-stack-change', { detail: next }))
  return next
}

export function addToBuilder(...ids: string[]) {
  return writeBuilder([...readBuilder(), ...ids])
}
